angular.module('app.controllers.understanding_bill', []).controller('UnderstandingBillController',
    ['$rootScope', '$scope', '$log', '$timeout', '$animate', function ($rootScope, $scope, $log, $timeout, $animate) {

  'use strict';

  $log.debug('UnderstandingBillController()');

  $scope.placement = "mouse";
  $scope.trigger = "click";

  $scope.sides = ["View Front of Bill", "View Back of Bill"];
  $scope.sideSelection = 0;

  $scope.types = ["Central Arizona", "Southern Arizona", "Southern California", "Northern California", "Northern Nevada", "Southern Nevada"];
  $scope.typeSelection = 2;
  $scope.urls = [
    {
      front: "readbill_centralarizona",
      back: "Arizona-Back-of-Bill"
    }
    , {
      front: "readbill_soarizona",
      back: "Arizona-Back-of-Bill"
    }
    , {
      front: "readbill_socalifornia",
      back: "California-Back-of-Bill"
    }
    , {
      front: "readbill_nocalifornia",
      back: "California-Back-of-Bill"
    }
    , {
      front: "readbill_nonevada",
      back: "Nevada-Back-of-Bill"
    }
    , {
      front: "readbill_sonevada",
      back: "Nevada-Back-of-Bill"
    }
  ];

  $scope.updateImage = function () {
    var prefix = WEB_PREFIX || '';
    if ($scope.sideSelection === 0) {
      $scope.billImage = prefix + "images/understanding-bill/" + $scope.urls[$scope.typeSelection].front + ".png";
      $scope.map = "#" + $scope.urls[$scope.typeSelection].front;
    }
    else {
      $scope.billImage = prefix + "images/understanding-bill/" + $scope.urls[$scope.typeSelection].back + ".png";
      $scope.map = "#nomap";
    }
  };

  $scope.setSide = function (value) {
    $scope.sideSelection = value;
    $scope.updateImage();
  };

  $scope.setImage = function (value) {
    $scope.typeSelection = value;
    $scope.updateImage();
  };

  $scope.popoverCtrlSet = false;

  /* Offset the popover under the bill hotspot */
  $scope.positionPopover = function (upperLeft, bottomRight) {
    // Only allow one popup at a time
    if (!$scope.popoverCtrlSet) {
      angular.element(document.body).bind('click', function (e) {
        $scope.popoverCtrlSet = true;
        //Find all elements with the popover attribute
        var popups = document.querySelectorAll('*[popover]');
        if (popups) {
          //Go through all of them
          for (var i = 0; i < popups.length; i++) {
            //The following is the popover DOM element
            var popup = popups[i];
            //The following is the same jQuery lite element
            var popupElement = angular.element(popup);

            //If the following condition is met, then the click does not correspond
            //to a click on the current popover in the loop or its content.
            //So, we can safely remove the current popover's content and set the
            //scope property of the popover
            if (popup != e.target) {
              if (popupElement.next().hasClass('popover')) {
                //Remove the popover content
                popupElement.next().remove();
                //Set the scope to reflect this
                popupElement.scope().tt_isOpen = false;
              }
            }
          }
        }
      });
    }
    // position the popup under the hotspot
    var el = $('div.popover');
    el.css("margin-left", upperLeft);
    el.css("margin-top", bottomRight);

  };

  $scope.updateImage();


}]);


